<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "analytics",
};
</script>

<style>
</style>